





























































































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import tableCom from "./components/tableCom.vue";
import { returnManagement } from "@/req/ReturnsManage";
import { gameList } from "@/req/gameManage";
import { serverInfo } from "@/req/shopManage";
import md5 from "js-md5";

@Component({
  components: { headerTitle, tableCom },
})
export default class Home extends Vue {
  // 搜索
  public commodityId = "";
  public gameName = "";
  public gameId = "";
  public gameList = [];
  public serverId = "";
  public serverList = [];
  public sellAcount = "";
  public buyAcount = "";
  public minPrice = "";
  public maxPrice = "";
  // 统计数
  public returnOrderNum = "";
  public returnAountNum = "";
  // 分页
  public total = 0;
  public pageNum = 1;
  public pageSize = 50;
  // 导出key
  public signKey = "RMOTTem0jK6EZrGQjudkoeHLSbSTJ8Kt";

  public mounted() {
    this.getGameList();
    this.returnManagement();
  }

  // 获取游戏列表
  public async getGameList() {
    const res = await gameList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      this.gameList = res.data;
    }
  }

  // 获取游戏区服列表
  public async getServerList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      game_id: this.gameId,
    };
    const res = await serverInfo(obj);
    if (res.code == 0) {
      this.serverList = res.data;
    }
  }
  // 选择游戏
  public gameSelect(gameId) {
    if (gameId !== undefined) {
      this.getServerList();
    }
  }
  // 获取表格数据
  public async returnManagement() {
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      limit: this.pageSize,
      page: this.pageNum,
      commodity_id: this.commodityId,
      game_id: this.gameId,
      server_id: this.serverId,
      seller_username: this.sellAcount,
      purchaser_username: this.buyAcount,
      min_price: this.minPrice,
      max_price: this.maxPrice,
    };
    const res = await returnManagement(obj);
    if (res.code == 0) {
      this.total = res.data.total;
      this.returnOrderNum = res.data.deliver_order_num;
      this.returnAountNum = res.data.deliver_account_num;
      const $tableCom: any = this.$refs.tableCom;
      $tableCom.show(res.data.data);
    }
  }
  // 条件搜素
  public toSearch() {
    this.returnManagement();
  }
  // 导出
  public toExcel() {
    const sign = `token=${this.$fn.cookies.getToken()}
    &commodity_id=${this.commodityId == undefined ? "" : this.commodityId}
    &game_id=${this.gameId == undefined ? "" : this.gameId}
    &server_id=${this.serverId == undefined ? "" : this.serverId}
    &seller_username=${this.sellAcount == undefined ? "" : this.sellAcount}
    &purchaser_username=${this.buyAcount == undefined ? "" : this.buyAcount}
    &min_price=${this.minPrice == undefined ? "" : this.minPrice}
    &max_price=${this.maxPrice == undefined ? "" : this.maxPrice}
    `;
    const signKey = `${sign}${this.signKey}`;
    const windowUrl = `${
      this.$HTTP_API.ReturnsManage.exportCsv
    }?${sign}&sign=${md5(signKey)}`;
    window.open(windowUrl);
  }

  // 分页
  public pageChange(i) {
    this.pageNum = i;
    this.returnManagement();
  }
  public sizeChange(i) {
    this.pageSize = i;
    this.pageNum = 1;
    this.returnManagement();
  }
}
